export enum UpdatedItemsBehaviour {
    ALWAYS = "ALWAYS",
    NEVER = "NEVER",
    PROFILE = "PROFILE"
}

export function formatUpdatedItemsBehaviour(value?: UpdatedItemsBehaviour) {
    switch (value) {
        case UpdatedItemsBehaviour.ALWAYS:
            return "Always";
        case UpdatedItemsBehaviour.NEVER:
            return "Never";
        case UpdatedItemsBehaviour.PROFILE:
            return "Profile";
        default:
            return "";
    }
}

export type UpdatedItemsBehaviourContext = "report" | "aiExtractor";

export function describeUpdatedItemsBehaviour(value?: UpdatedItemsBehaviour, context: UpdatedItemsBehaviourContext = "report") {
    if (context === "aiExtractor") {
        switch (value) {
            case UpdatedItemsBehaviour.ALWAYS:
                return "Re-extract every updated item.";
            case UpdatedItemsBehaviour.NEVER:
                return "Do not re-extract updated items.";
            case UpdatedItemsBehaviour.PROFILE:
                return "Re-extract only updated items matching the selected profile.";
            default:
                return "";
        }
    }

    switch (value) {
        case UpdatedItemsBehaviour.ALWAYS:
            return "Report every updated item.";
        case UpdatedItemsBehaviour.NEVER:
            return "Do not report updated items.";
        case UpdatedItemsBehaviour.PROFILE:
            return "Report only updated items matching the selected profile.";
        default:
            return "";
    }
}
